<template>
  <div class="calendar_box">
    <FullCalendar
        class='demo-app-calendar'
        :options='calendarOptions'
        :onselect="onDateSelect"
        ref="fullCalendar"
        v-contextmenu:contextmenu
    >

      <template v-slot:eventContent='arg'>
        <div class="schedule_normal" style="font-size: larger;text-align: center" >
          <div v-for="argItem in arg.event.extendedProps.scheduleItemList" style="margin-bottom: 20px;border-top: solid 2px lightgrey">
            <div>{{ argItem.order_no }}</div>
            <div>{{ argItem.from_product_name }}</div>
            <div style="color: #409EFF">{{ argItem.to_product_name }}</div>
            <div>{{ argItem.schedule_cnt }} ({{ argItem.finish_cnt }})</div>
          </div>
        </div>

      </template>

    </FullCalendar>

    <v-contextmenu ref="contextmenu">
      <v-contextmenu-item @click="addSchedule()">添加排产</v-contextmenu-item>
    </v-contextmenu>

    <div class="my_toolbar">
      <el-button type="primary" @click="scheduleQuery" class="toolbar_item">查询</el-button>
      <el-button type="primary" @click="dialogFormExport = true" class="toolbar_item">导出</el-button>
    </div>

    <div style="margin-top: 5px;margin-left: 10px">
      * 右键添加排产；点击可查看详情
    </div>

    <!--添加排产dialog -->
    <el-dialog title="添加排产" :model="formData" v-model="dialogFormVisible" style="width: 1000px">
      <el-form label-width="130px" :rules="rules">
        <el-row>
          <el-form-item label="日期：" prop="star">
            <el-date-picker
                v-model="formData.schedule_date"
                type="date"
                placeholder="请选择日期"
                style="width: 135px"
            />
          </el-form-item>

          <el-form-item label="开始时间：">
            <el-time-select
                v-model="formData.start_time"
                start="00:00"
                step="00:30"
                end="24:00"
                placeholder="请选择时间"
                style="width: 135px"
            />
          </el-form-item>
          <el-form-item label="结束时间：">
            <el-time-select
                v-model="formData.end_time"
                start="00:00"
                step="00:30"
                end="24:00"
                placeholder="请选择时间"
                style="width: 150px"
            />
          </el-form-item>
        </el-row>

        <el-row v-for="item in itemList" :key="item.id" class="row">
          <el-form-item label="订单编号：" prop="star">
            <el-select v-model="item.order_id" style="width: 400px" clearable>
              <el-option v-for="orderNo in orderList" :key="orderNo.id" :label="orderNo.order_detail"
                         :value="orderNo.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="排产数量：">
            <el-input-number v-model="item.schedule_cnt" style="" clearable controls-position="right" :min="1">
            </el-input-number>
          </el-form-item>
          <div class="close" @click="removeItemRow(item.nanoid)">
            <el-icon v-if="this.itemList.findIndex(items => items.nanoid === item.nanoid) !== 0" :size="30">
              <ElIconClose></ElIconClose>
            </el-icon>
          </div>
          <el-button style="margin: 0 0 0 10px" @click="addItemRow(1)"
                     v-if="this.itemList.findIndex(items => items.nanoid === item.nanoid) === 0">添加订单行</el-button>
        </el-row>

        <el-form-item label="备注：">
          <el-input type="textarea" v-model="formData.remark" style="width: 700px" clearable>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="submit" :loading="loading">提交</el-button>
          <KfMessage ref="scheduleMessage"/>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--导出排产dialog -->
    <el-dialog title="排产导出" :model="form" v-model="dialogFormExport" style="width:700px">
      <FrameForm componentParam="schedule_export" :init-data="formData"/>
    </el-dialog>

    <!--排产详情dialog -->
    <el-dialog title="排产详情" :model="form" v-model="dialogForm" style="width: 1000px">
      <el-form label-width="130px" :rules="rules">
        <el-row>
          <el-form-item label="日期：" prop="star">
            <el-date-picker
                v-model="form.schedule_date"
                type="date"
                placeholder="请选择日期"
                style="width: 135px"
            />
          </el-form-item>

          <el-form-item label="开始时间：">
            <el-time-select
                v-model="form.start_time"
                start="00:00"
                step="00:30"
                end="24:00"
                placeholder="请选择时间"
                style="width: 135px"
            />
          </el-form-item>
          <el-form-item label="结束时间：">
            <el-time-select
                v-model="form.end_time"
                start="00:00"
                step="00:30"
                end="24:00"
                placeholder="请选择时间"
                style="width: 150px"
            />
          </el-form-item>
        </el-row>

        <el-row v-for="item in itemList" :key="item.id" class="row">
          <el-form-item label="订单编号：" prop="star">
            <el-select v-model="item.order_id" style="width: 400px" clearable>
              <el-option v-for="orderNo in orderList" :key="orderNo.id" :label="orderNo.order_detail"
                         :value="orderNo.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="排产数量：">
            <el-input-number v-model="item.schedule_cnt" style="" clearable controls-position="right" :min="1">
            </el-input-number>
          </el-form-item>
          <div class="close" @click="removeItemRow(item.nanoid)">
            <el-icon :size="30" v-if="this.itemList.length > 1">
              <ElIconClose></ElIconClose>
            </el-icon>
          </div>
        </el-row>

        <el-form-item label="备注：">
          <el-input type="textarea" v-model="form.remark" style="width: 400px" clearable>
          </el-input>
        </el-form-item>
          <el-form-item>
            <el-col :span="18" style="margin-top: 10px">
              <el-button @click="updateSchedule" :loading="loading" >编辑</el-button>
              <el-button @click="deleteSchedule" :loading="loading" >删除排产</el-button>
            </el-col>
          </el-form-item>
        </el-form>
    </el-dialog>
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import {nanoid} from "nanoid";

export default {
  inject: ['$fn'],
  name: "RebuildSchedule",
  components: {
    FullCalendar,
  },
  data() {
    return {
      activeName: 'first',
      rules: {
        star: [{required: true, message: '', trigger: 'blur'}],
      },
      // scheduleType: [],
      // scheduleState: [],
      userList: [],
      dialogForm: false,
      dialogFormVisible: false,
      dialogFormExport: false,
      users: [],
      params: {},
      viewVisible: false,
      selectId: 0,
      selectDate: '',
      saveVisible: false,
      queryListEventMap: {
        button_id: '',
        query_id: '',
        start_date: ''
      },
      formExport: {
        user_id: '',
        export_start_time: '',
        export_end_time: ''
      },
      form: {
        id: '',
        user_id: '',
        schedule_date: '',
        start_time: '',
        end_time: '',
        order_id:'',
        schedule_cnt: 0,
        remark: '',
      },
      formData: {
        schedule_date: '',
        start_time: '',
        end_time: '',
        user_id: '',
        order_id:'',
        schedule_cnt: 0,
        remark: '',
      },
      itemList:[],//订单行
      orderList:[],//订单编号
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        aspectRatio: 2.2,
        allDaySlot: false,
        locale: "zh-cn",
        fixedWeekCount: false,
        customButtons: {
          next: {
            click: this.nextClick
          },
          prev: {
            click: this.prevClick
          },
          today: {
            text: "今天",
            click: this.todayClick
          },
        },
        headerToolbar: {
          left: "prev,next,today",
          center: "title",
          right: "",
        },
        initialView: "timeGridWeek",
        events: [],
        firstDay: 1,
        editable: false,
        selectable: true,
        // selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        eventClick: this.handleEventClick,
        select: this.onDateSelect
      },
      currentEvents: [],
      eventGuid: 0,
    };
  },
  created() {
    this.fullName();
    this.scheduleQuery()
    this.getUserList()
  },
  methods: {
    windowResize() {
      this.$refs.fullCalendar.getApi().updateSize()
    },

    nextClick() {
      this.$refs.fullCalendar.getApi().next()
      this.scheduleQuery()
    },

    prevClick() {
      this.$refs.fullCalendar.getApi().prev()
      this.scheduleQuery()
    },

    todayClick() {
      this.$refs.fullCalendar.getApi().today()
      this.scheduleQuery()
    },

    addItemRow(cnt) {
      for(var i=0;i<cnt;i++){
        this.itemList.push({
          nanoid: nanoid(),
        })
      }
    },
    removeItemRow(nanoid) {
      let index = this.itemList.findIndex(item => item.nanoid === nanoid);
      this.itemList.splice(index, 1);
    },

    //清空表单
    clearData() {
      this.formData.schedule_date = ''
      this.formData.start_time = ''
      this.formData.end_time = ''
      this.formData.order_id = ''
      this.formData.schedule_cnt = 0
      this.formData.remark = ''
      this.form.user_id = ''
      this.form.title = ''
      this.form.schedule_date = ''
      this.form.start_time = ''
      this.form.end_time = ''
      this.form.schedule_cnt = 0
      this.form.remark = ''
      this.dialogFormVisible = false;
    },

    //获取操作人
    fullName() {
      this.formData.user_id = this.$store.state.core.currentUser?.id
      this.form.user_id = this.$store.state.core.currentUser?.id
    },

    //添加排产表单
    addSchedule() {
      this.dialogFormVisible = true;
      this.formData.order_id = '';
      this.formData.schedule_cnt = 0;
      this.itemList = [];
      this.addItemRow(3);
      this.getOrderNo()
    },

    //获取订单编号
    async getOrderNo(){
      this.orderList = await this.$http('rebuildScheduleService.getOrderNo',this.formData)
    },

    //添加排产
    async submit() {
      if (!this.formData.schedule_date) {
        return this.$message.error('请选择日期')
      }
      var i = 1;
      for (const orderItem of this.itemList) {
        if (i === 1) {
          if (!orderItem.order_id) {
            this.$message.error('第' + i + '行，订单号为空')
            return;
          }
          if (!orderItem.schedule_cnt) {
            this.$message.error('第' + i + '行，排产数量为空')
            return;
          }
        } else {
          if (!orderItem.order_id) {
            let index = this.itemList.findIndex(item => item.nanoid === orderItem.nanoid);
            this.itemList.splice(index, i);
          } else {
            if (!orderItem.schedule_cnt) {
              this.$message.error('第' + i + '行，排产数量为空')
              return;
            }
          }
        }
        i = i + 1;
      }

      this.formData.itemList = this.itemList
      await this.$http('rebuildScheduleService.addSchedule', this.formData).then(async data => {
        await this.scheduleQuery()
        this.clearData()
      }, errMsg => {
        return this.$refs.scheduleMessage.showError(errMsg)
      });

    },

    //查询排产
    async scheduleQuery() {
      if (!this.formData.user_id) {
        return
      }
      this.calendarOptions.events = await this.$http('rebuildScheduleService.getSchedule', this.formData)
    },

    //查询详情
    async handleEventClick(clickInfo) {
      this.clearData()
      this.dialogForm = true;
      this.itemList = [];

      let params = {schedule_id: clickInfo.event.id}
      this.form = await this.$http('rebuildScheduleService.getScheduleDetails', params)
      this.itemList = this.form.itemList

      await this.getOrderNo()
    },

    //修改排产
    async updateSchedule() {

      // let params = {form:this.form}
      await this.$http('rebuildScheduleService.updateSchedule', this.form).then(async data => {
            await this.scheduleQuery()
            this.$message.success('修改成功')
            this.dialogForm = false
          },
      )
    },

    //删除排产
    deleteSchedule() {
      this.$http('rebuildScheduleService.deletesSchedule', this.form).then(data => {
        this.dialogForm = false;
        this.scheduleQuery()
        this.$message.success('删除成功')
        this.clearData()
      })
    },

    isExport() {
      this.dialogFormExport = true;
    },

    onDateSelect(selectionInfo) {
      if(!selectionInfo){
        return
      }

      this.formData.schedule_date = selectionInfo.start.format("yyyy-MM-dd");
      this.formData.start_time = selectionInfo.start.format("hh:mm");
      this.formData.remind_time = selectionInfo.start.format("hh:mm");
      this.formData.end_time = selectionInfo.end.format("hh:mm");
    },

    async getUserList() {
       this.userList = await this.$http('sysDsService.getSubUsers')
    }
  },

}

Date.prototype.format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
}

</script>

<style scoped>
/* 去掉控件里的边框，背景色*/
.fc-v-event {
  background-color: white !important;
  border: none !important;
}

.fc-timegrid-event{
  box-shadow: none !important;
}

.fc-highlight{
  background: rgba(188,232,241,.7)  !important;
}

.fc-event-main{
  padding: 1px 0px 1px !important;
}

</style>

<style lang="less" scoped>
.calendar_box {
  width: 100%;
  height: 80%;
  padding: 20px;
}

.my_toolbar {
  position: absolute;
  top: 25px;
  right: 50px;
  text-align: left;
  line-height: 40px;
  vertical-align: middle;
  /*border: 1px dotted lightgray;*/
  display: inline-flex;

}

.toolbar_item {
  margin-right: 10px;
}

.schedule_business_trip{
  background-color: burlywood;
  border-left: 4px solid orange;
  color: #ffffff;
  padding: 2px;
  font-size: larger;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.schedule_normal{
  border-left: 4px solid #42b983;
  color: black;
  background-color: #E7F3F7;
  padding: 2px;
  font-size: larger;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.schedule_leave{
  background-color: lightcoral;
  border-left: 4px solid red;
  color: #ffffff;
  padding: 2px;
  font-size: larger;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.schedule_out{
  background-color: lightcoral;
  border-left: 4px solid red;
  color: #ffffff;
  padding: 2px;
  font-size: larger;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.schedule_remind{
  background-color: #6699CC;
  border-left: 4px solid #1a70ff;
  color: #ffffff;
  padding: 2px;
  font-size: larger;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scheduleDetail {
  font-size: 16px;
}

</style>